import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { HttpService } from '../../core/services/http.service';
import { HttpParams } from '@angular/common/http';
import { Anouncement } from '../models/anouncement';
import { IList } from '../../core/interface/IList';
import { AnouncementItem } from '../models/anouncementItem';

@Injectable()
export class AnouncementService {

    constructor(
        private http: HttpService
    ) { }

    getAnoucements(pageIndex, pageSize): Observable<IList<AnouncementItem>> {
        const params = new HttpParams()
            .set('pageNumber', pageIndex)
            .set('pageSize', pageSize)
            .set('subject', '')
            .set('keyword', '');
        return this.http.get('api/getNewsList', { params: params })
            .switchMap(res => this.http.mapRes(res))
            .catch(err => {
                return Observable.of({ listdata: [], totolCount: 0 });
            });
    }

    getAnouncementDetail(id): Observable<Anouncement> {
        const params = new HttpParams().set('id', id);
        return this.http.get('api/getNewsInfo', { params })
            .switchMap(res => this.http.mapRes(res));
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/anouncement.service.ts